"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccidentalButtons = AccidentalButtons;
exports.Button = Button;
exports.Callout = Callout;
exports.Checkbox = Checkbox;
exports.CheckboxGroup = CheckboxGroup;
exports.DesignRow = DesignRow;
exports.Dropdown = Dropdown;
exports.Modal = Modal;
exports.Paragraph = Paragraph;
exports.Radio = Radio;
exports.RadioGroup = RadioGroup;
exports.TextField = TextField;
exports.getWWNDS = getWWNDS;
exports.setWWNDS = setWWNDS;
exports.toText = toText;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Alert = _interopRequireDefault(require("react-bootstrap/Alert"));
var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _reactSelect = _interopRequireDefault(require("react-select"));
require("../ModalFeedback/ModalFeedback.scss");
var _reactUseIdHook = require("react-use-id-hook");
var _Image = require("react-bootstrap/esm/Image");
var _MusicUtil = require("../TaskScaleBuilder/MusicUtil");
var _excluded = ["color"],
  _excluded2 = ["label", "labelId", "description", "className", "innerClassName", "innerRef", "placeholder", "inline", "labelBottom", "value"],
  _excluded3 = ["value", "isSelected", "children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"];
var DEBUG = false;

// A set of components that take Norton props and have Bootstrap fallbacks.

// Dropdown, Radio, RadioGroup, Checkbox, CheckboxGroup

var wwnds = false;
try {
  var N = require('@wwnds/react');
  console.log("N", N);
  //var S = require('@wwnds/core/dist/main.css')
  //console.log("S", S)
  setWWNDS(true);
} catch (e) {
  setWWNDS(false);
}
function setWWNDS(v) {
  wwnds = v;
  var root = document.querySelector(":root");
  var theme = root.getAttribute('data-theme');
  if (v && theme !== "wwnds") {
    root.setAttribute('data-theme', "wwnds");
  } else if (!v && theme === "wwnds") {
    root.removeAttribute('data-theme');
  }
}
function getWWNDS() {
  return wwnds;
}
function toText(node) {
  if (['string', 'number', 'boolean'].includes(typeof node)) {
    return node.toString();
  }
  if (!node) {
    return '';
  }
  if (Array.isArray(node)) {
    return node.map(toText).join('');
  }
  var props = node.props || {};
  if (!props || !props.children) {
    return '';
  }
  return toText(props.children);
}
var colors_to_variants = {
  blue: 'primary',
  grey: 'secondary',
  gray: 'secondary',
  green: 'success',
  yellow: 'warning',
  red: 'danger',
  teal: 'info',
  primary: 'primary',
  warning: 'warning',
  error: 'danger',
  success: 'success'
};
var color_to_variant = function color_to_variant(color) {
  return colors_to_variants[color] || 'dark';
};
var variant = function variant(_variant, color) {
  if (_variant === 'solid' || _variant === undefined) return color_to_variant(color);
  if (_variant === 'ghost') return 'link';
  if (_variant === 'outline') return 'outline-' + color_to_variant(color);
  return _variant + '-' + color;
};
function Callout(props) {
  return wwnds ? /*#__PURE__*/_react.default.createElement(N.Callout, props) : /*#__PURE__*/_react.default.createElement(_Alert.default, Object.assign({}, props, {
    variant: props.color
  }));
}
function Button(_ref) {
  var color = _ref.color,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return wwnds ? /*#__PURE__*/_react.default.createElement(N.Button, Object.assign({
    color: color
  }, props)) : /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({}, props, {
    variant: variant(props.variant, color),
    ref: props.buttonRef
  }), props.textClass ? /*#__PURE__*/_react.default.createElement("span", {
    className: props.textClass
  }, props.children) : props.children);
}
function Modal(props) {
  return wwnds ? /*#__PURE__*/_react.default.createElement(N.Modal, props) : /*#__PURE__*/_react.default.createElement(_Modal.default, Object.assign({}, props, {
    show: props.isOpen,
    onHide: props.onRequestClose
  }), /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    closeButton: !props.hideCloseButton
  }, props.hideTitle ? '' : props.title), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, null, props.children), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, props.actions));
}
function Dropdown(props) {
  var id = (0, _reactUseIdHook.useId)();
  if (wwnds && props.label === undefined) {
    throw new Error("Dropdown components must specify prop 'label' in order to be accessible.");
  }
  if (props.label === undefined && props.labelId === undefined) {
    throw new Error("Dropdown components must specify prop 'label' or 'labelId' in order to be accessible.");
  }
  var label = props.label,
    labelId = props.labelId,
    description = props.description,
    className = props.className,
    innerClassName = props.innerClassName,
    innerRef = props.innerRef,
    placeholder = props.placeholder,
    inline = props.inline,
    labelBottom = props.labelBottom,
    value = props.value,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded2);
  var selectedValue = value == undefined ? undefined : null;
  var options = _react.default.Children.map(props.children, function (child, i) {
    if (!child) {
      return;
    }
    DEBUG && console.log("Dropdown child", child.props);
    var obj = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, child.props), {}, {
      label: child.props.label
    });
    delete obj.selected;
    delete obj.children;
    if (obj.value === value) {
      selectedValue = obj;
    }
    return obj;
  });
  var incorrectColor = 'red';
  var correctColor = 'green';
  var imgCorrect = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='".concat(correctColor, "' class='bi bi-check' viewBox='0 0 16 16'%3E%3Cpath d='M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z'/%3E%3C/svg%3E\")");
  var imgIncorrect = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='".concat(incorrectColor, "' class='bi bi-x' viewBox='0 0 16 16'%3E%3Cpath d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")");
  var bg;
  var isCorrect = false;
  var isIncorrect = false;
  var content = '" "';
  if (props.isValid === false) {
    bg = imgIncorrect;
    isIncorrect = true;
    content = '"Incorrect: "';
  } else if (props.isValid !== undefined && props.isValid !== null) {
    bg = imgCorrect;
    isCorrect = true;
    content = '"Correct: "';
  }
  DEBUG && console.log("Dropdown", props.value, selectedValue);
  return wwnds ? /*#__PURE__*/_react.default.createElement(N.Dropdown, Object.assign({}, props, {
    ref: props.innerRef
  })) : /*#__PURE__*/_react.default.createElement("span", {
    className: "bdg-dropdown" + (className ? " " + className : "")
  }, !labelBottom && !labelId && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    style: inline ? {
      display: 'inline'
    } : undefined
  }, label), /*#__PURE__*/_react.default.createElement(_reactSelect.default, Object.assign({
    options: options,
    ref: innerRef,
    className: innerClassName
  }, props, {
    isDisabled: props.disabled,
    styles: {
      valueContainer: function valueContainer(styles) {
        return props.isValid !== undefined ? (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styles), {}, {
          alignItems: 'center',
          display: 'flex',
          ':before': {
            backgroundImage: bg,
            content: content,
            fontSize: 0,
            marginRight: 6,
            width: 16,
            height: 16,
            transform: 'scale(2)',
            display: 'inline-block'
          }
        }) : styles;
      },
      control: function control(styles) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styles), {}, {
          backgroundColor: isCorrect ? '#e1faef' : isIncorrect ? '#fbefed' : undefined,
          borderColor: isCorrect ? '#00cc9a' : isIncorrect ? '#c51c00' : undefined
        });
      },
      indicatorSeparator: function indicatorSeparator(styles) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styles), {}, {
          opacity: 0
        });
      },
      singleValue: function singleValue(styles) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styles), {}, {
          color: 'unset'
        });
      },
      dropdownIndicator: function dropdownIndicator(styles, state) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styles), {}, {
          opacity: state.isDisabled ? 0 : 1
        });
      },
      option: function option(styles, state) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styles), {}, {
          color: state.isFocused ? '#00adef' : undefined,
          backgroundColor: state.isFocused ? '#f5f1f5' : undefined,
          fontWeight: state.isFocused ? 600 : undefined
        });
      },
      menuPortal: function menuPortal(styles) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styles), {}, {
          zIndex: 9999
        });
      }
    },
    isSearchable: false,
    value: selectedValue,
    placeholder: "Select...",
    "aria-describedby": description ? "description-" + id : undefined,
    "aria-labelledby": labelId ? labelId : undefined,
    onChange: function onChange(e, b) {
      DEBUG && console.log("Dropdown onChange", e, b);
      return props.onChange && props.onChange((0, _objectSpread2.default)({
        value: e === null || e === void 0 ? void 0 : e.value,
        target: {
          value: e === null || e === void 0 ? void 0 : e.value
        }
      }, e));
    },
    menuPosition: "absolute",
    menuPortalTarget: document.body
  })), labelBottom && !labelId && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    style: inline ? {
      display: 'inline'
    } : undefined
  }, label), description && /*#__PURE__*/_react.default.createElement("span", {
    id: "description-" + id
  }, description)); /*<span className={"bdg-dropdown" + (className ? " " + className : "")}>
                    {!labelBottom && !labelId && <label htmlFor={id} style={inline ? {display: 'inline'} : undefined}>{label}</label>}
                    <BForm.Control
                    title={toText(label)}
                    defaultValue=""
                    {...props}
                    className={innerClassName}
                    id={id}
                    value={value}
                    aria-describedby={description ? "description-" + id : undefined}
                    aria-labelledby={labelId ? labelId : undefined}
                    onChange={e=>{
                    return props.onChange && props.onChange({value: e.target.value, ...e})
                    }}
                    as="select"
                    ref={innerRef}
                    >
                    <option value="" disabled aria-label="Select an option">{placeholder || "Select"}</option>
                    {props.children}
                    </BForm.Control>
                    {labelBottom && !labelId && <label htmlFor={id} style={inline ? {display: 'inline'} : undefined}>{label}</label>}
                    {description && <span id={"description-" + id}>{description}</span>}
                    </span>*/
}

if (!wwnds) {
  Dropdown.Option = function (_ref2) {
    var value = _ref2.value,
      isSelected = _ref2.isSelected,
      children = _ref2.children,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded3);
    if (value === undefined) {
      throw new Error("Dropdown options must specify prop 'value' in order to be accessible.");
    }
    DEBUG && console.log("Dropdown.Option asdf", value);
    return /*#__PURE__*/_react.default.createElement("option", Object.assign({
      value: value
    }, props), toText(children));
  };
} else {
  Dropdown.Option = function (props) {
    DEBUG && console.log("Dropdown.Option", props);
    return /*#__PURE__*/_react.default.createElement(N.Dropdown.Option, props);
  };
}
function Radio(props) {
  var children = props.children,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded4);
  return wwnds ? /*#__PURE__*/_react.default.createElement(N.Radio, props) : /*#__PURE__*/_react.default.createElement(_Form.default.Check, Object.assign({
    id: props.value,
    label: children
  }, rest, {
    // label
    type: "radio"
  }));
}
function RadioGroup(props) {
  return wwnds ? /*#__PURE__*/_react.default.createElement(N.RadioGroup, props) : /*#__PURE__*/_react.default.createElement(_Form.default.Group, props, props.label && /*#__PURE__*/_react.default.createElement(_Form.default.Label, null, props.label), props.children);
}
function Checkbox(props) {
  var children = props.children,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded5);
  return wwnds ? /*#__PURE__*/_react.default.createElement(N.Checkbox, props) : /*#__PURE__*/_react.default.createElement(_Form.default.Check, Object.assign({
    id: props.value,
    label: children
  }, rest, {
    // label
    type: "checkbox"
  }));
}
function CheckboxGroup(props) {
  return wwnds ? /*#__PURE__*/_react.default.createElement(N.CheckboxGroup, props) : /*#__PURE__*/_react.default.createElement(_Form.default.Group, props, props.label && /*#__PURE__*/_react.default.createElement(_Form.default.Label, null, props.label), props.children);
}

// row for evenly spacing out components
function DesignRow(props) {
  var children = [];
  try {
    props.children.map(function (v, k) {
      children.push(v);
    });
  } catch (_unused) {
    children = [props.children];
  }
  return /*#__PURE__*/_react.default.createElement(_Row.default, null, props.children.map(function (v, k) {
    return /*#__PURE__*/_react.default.createElement(_Col.default, null, v);
  }));
}

// wrapper around p tag for IB
function Paragraph(props) {
  return /*#__PURE__*/_react.default.createElement("p", {
    style: props.style
  }, props.text);
}
function TextField(props) {
  return wwnds ? /*#__PURE__*/_react.default.createElement(N.TextField, props) : /*#__PURE__*/_react.default.createElement(_Form.default.Text, props);
}
function AccidentalButtons(props) {
  var accidentalButtons = [];
  if (props.musicButtonNote) {
    accidentalButtons.push( /*#__PURE__*/_react.default.createElement(N.Radio, {
      id: "none",
      key: "none",
      value: "none",
      labelClass: "sr-only",
      "aria-label": "no accidental",
      onChange: function onChange() {
        props.setAccidental("");
      },
      checked: props.accidental === "",
      thumbnail: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
        className: "icon-image revert-dark-mode",
        src: _MusicUtil.icons.whole,
        alt: ""
      }))
    }));
  }
  var _loop = function _loop() {
    var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 1),
      value = _Object$entries$_i[0];
    if (props.activeButtons[props.accidentals_to_props[value]]) {
      accidentalButtons.push( /*#__PURE__*/_react.default.createElement(N.Radio, {
        id: value,
        key: value,
        value: value.replace('dbl', 'double '),
        labelClass: "sr-only",
        onChange: function onChange() {
          props.setAccidental(props.accidentals[value]);
        },
        checked: props.accidental === props.accidentals[value],
        thumbnail: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
          className: "icon-image revert-dark-mode",
          src: _MusicUtil.icons[value],
          alt: ""
        }))
      }));
    }
  };
  for (var _i = 0, _Object$entries = Object.entries(props.accidentals); _i < _Object$entries.length; _i++) {
    _loop();
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, wwnds ? /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-button-group notation-toolbar-box"
  }, /*#__PURE__*/_react.default.createElement(N.RadioGroup, {
    label: /*#__PURE__*/_react.default.createElement("span", {
      style: {
        position: "absolute",
        margin: "4px 0px 0px -234px"
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      id: "notation-options",
      className: "notation-text"
    }, "Notation Options:")),
    style: {
      display: "inline-block",
      margin: "5px 0px 0px 250px"
    },
    "aria-label": "Apply an accidental"
  }, accidentalButtons)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-button-group notation-toolbar-box",
    style: {
      display: "inline-block"
    },
    role: "radiogroup",
    "aria-label": "Apply an accidental"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      float: "left",
      margin: "9px 0px 9px 16px"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "notation-text"
  }, "Notation Options:")), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-toolbar",
    style: {
      float: "left"
    }
  }, props.musicButtonNote && /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-image-container"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "notation-checkbox",
    type: "radio",
    name: "no accidental",
    value: "none",
    id: "none",
    "aria-label": "no accidental",
    onChange: function onChange() {
      props.setAccidental("");
    },
    checked: props.accidental === ""
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "notation-label",
    htmlFor: "none"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "icon-image revert-dark-mode",
    src: _MusicUtil.icons.whole,
    alt: ""
  }))), Object.keys(props.accidentals).map(function (value, code) {
    return props.activeButtons[props.accidentals_to_props[value]] && /*#__PURE__*/_react.default.createElement("div", {
      className: "icon-image-container",
      key: value
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "notation-checkbox accidental",
      type: "radio",
      name: "accidental",
      id: value,
      value: value,
      "aria-label": value.replace('dbl', 'double '),
      onChange: function onChange() {
        props.setAccidental(props.accidentals[value]);
      },
      checked: props.accidental === props.accidentals[value]
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "notation-label",
      htmlFor: value,
      key: value
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "icon-image revert-dark-mode",
      src: _MusicUtil.icons[value],
      alt: ""
    })));
  })))));
}